import RecipientReportsTable from "./RecipientReportsTable"

export default RecipientReportsTable
